export default (token) => {
	return localStorage.removeItem('USER-TOKEN', token)
}
